import AbstractSpecificationVisitor from "../../../specification/visitors/AbstractSpecificationVisitor.js";
import AccountFormulaToken from "../../formulaToken/AccountFormulaToken.js";
import AccountGroupFormulaToken from "../../formulaToken/AccountGroupFormulaToken.js";
import AccountIntervalFormulaToken from "../../formulaToken/AccountIntervalFormulaToken.js";
import IntervalAccountGroup from "../../../chartOfAccounts/IntervalAccountGroup.js";
import SpecificationTokenizationError from "./SpecificationTokenizationError.js";

/**
 * Visitor used to tokenize formula nodes that contain a specification in their
 * account description.
 */
export default class SpecificationTokenizer extends AbstractSpecificationVisitor {
	visitAbstractSpecification(specification) {
		throw new SpecificationTokenizationError(specification);
	}

	visitCompositeSpecification(specification) {
		throw new SpecificationTokenizationError(specification);
	}

	visitNotSpecification(specification) {
		throw new SpecificationTokenizationError(specification);
	}

	visitAccountGroupSpecification(specification) {
		return new AccountGroupFormulaToken({
			groupId: specification.getGroupId(),
			groupLabel: specification.getName(),
		});
	}

	visitAccountIntervalSpecification(specification) {
		const intervals = IntervalAccountGroup.parseInterval(
			specification.getInterval(),
		);

		if (intervals.length !== 1) {
			throw new SpecificationTokenizationError(specification);
		}

		const interval = intervals[0];

		return new AccountIntervalFormulaToken({
			start: interval.start,
			end: interval.end,
		});
	}

	visitAccountNumberListSpecification(specification) {
		const accountNumbers = specification.getAccountNumbers();

		if (accountNumbers.length !== 1) {
			throw new SpecificationTokenizationError(specification);
		}

		return new AccountFormulaToken({ accountNumber: accountNumbers[0] });
	}
}
